import { Fragment, useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserStore } from '../../../../../modules/Auth/stores/authStore';
import {
  getUserPermissions,
  hasExactPermission,
} from '../../../../accessControl/utils';
import { Button } from '../../../../components/atoms/Button';
import { Typography } from '../../../../components/molecules/Typography';
import RedirectModel from '../../../../components/organism/RedirectModal';
import { useMenuHooks } from '../../../../hooks/useMenuHooks';
import { IMenuItem } from '../menuBar/menuItems';
import { MenuDropDown } from '../MenuDropDown';
import { menuItems, planoAdaptativoMenuItems } from './menuItems';
import './styles.css';
import { useGetHubResume } from '../../../../../modules/PlanoAdaptativo/hooks/ScheduleHub/useGetHubResume';
import { isMenuPlanoAdaptativo } from '../../../../utils/menu';

export default function BottomMenu() {
  const { data } = useGetHubResume();
  const scheduleId = String(data?.id) || '';
  const { pathname } = useLocation();
  const { callBack, isChecked } = useMenuHooks();

  const [redirectURL] = useState<string>('');
  const [openRedirect, setOpenRedirect] = useState<boolean>(false);
  const [redirectModule] = useState<string>('');

  const { user } = useUserStore();

  const setActive = (url: string) => {
    if (pathname?.includes(url)) {
      return 'selected';
    } else {
      return 'focusable';
    }
  };

  const setActiveItem = (url: string) => {
    if (pathname === '/') {
      if (url === '/') {
        return 'selected';
      } else {
        return 'black';
      }
    }

    if (url !== '/') {
      if (pathname?.includes(url)) {
        return 'selected';
      } else {
        return 'black';
      }
    } else {
      return 'black';
    }
  };

  const bgColorDropDown = user?.isDarkMode
    ? { backgroundColor: '#000C29' }
    : { backgroundColor: '#ffffff' };
  //@todo: ver como utilizar os design tokens

  const resolvePath = (path: string) => path.replace('UUID', scheduleId);

  const filteredMenuItems = useMemo(() => {
    if (isMenuPlanoAdaptativo())
      return planoAdaptativoMenuItems.map((e) => {
        const isMinhaArea = e.label === 'Minha Área';
        return {
          ...e,
          label: isMinhaArea ? 'Minha Área' : e.label.split(' ')?.at(0),
          href: isMinhaArea ? '/' : `/plano-adaptativo/${scheduleId}/${e.href}`,
        };
      });

    const userPermission = getUserPermissions(user);
    const menuItemsFiltered: IMenuItem[] = [];

    menuItems.forEach((menuItem) => {
      if (
        menuItem.permission &&
        hasExactPermission(userPermission, menuItem.permission) &&
        menuItem.items.length <= 0
      ) {
        menuItemsFiltered.push(menuItem);
        return;
      }

      const filteredItems = menuItem.items?.filter(
        (item) =>
          hasExactPermission(userPermission, item.permission) ||
          !item.permission
      );

      if (filteredItems && filteredItems.length > 0) {
        menuItemsFiltered.push({ ...menuItem, items: filteredItems });
      }
    });

    return menuItemsFiltered;
  }, [user]);

  return (
    <nav
      className={`h-[70px] w-full bg-color-lightest py-5 lg:hidden ${
        pathname?.includes('/exercicio/') ? 'hidden' : 'xs:block'
      }`}
    >
      <RedirectModel
        onCheck={() => callBack(redirectModule)}
        checked={isChecked(redirectModule)}
        onClose={() => setOpenRedirect(false)}
        isOpen={openRedirect}
        redirect={redirectURL}
      />
      <div className='flex h-8 items-center justify-between px-4'>
        {filteredMenuItems.map((menu, index) => {
          if (!user?.enableNewFeatures26 && menu.label === 'Flashcards') {
            return null;
          }

          const id = 'menu-mobile-' + menu.id;
          return (
            <Fragment key={id}>
              <Button
                allowReadOnly
                variant={setActiveItem(menu.href || '')}
                iconVariant='rounded'
                data-tooltip-id={`bottom-menu-${menu.id}`}
                size='mini'
                LeftIcon={menu.icon}
                orientation='vertical'
                asLink={menu.clickable}
                to={menu.clickable ? `${resolvePath(menu.href || '')}` : ''}
                className='bg-transparent relative'
              >
                <Typography className='text-xs text-mono-color-black'>
                  {menu.label}
                </Typography>
                {menu.label === 'Trilhas' && (
                  <div className='absolute right-0 top-0 h-[14px] w-[14px] rounded-circular bg-feedback-color-error-pure'>
                    <Typography size='mini' className='text-mono-color-white'>
                      1
                    </Typography>
                  </div>
                )}
              </Button>
              {menu.items.length > 0 && (
                <MenuDropDown
                  id={`bottom-menu-${menu.id}`}
                  offset={15}
                  // itens da metade direita alinham pela borda direita para
                  // o dropdown não estourar a tela e ser jogado para o lado
                  position={
                    index > filteredMenuItems.length / 2 ? 'top-end' : 'top'
                  }
                  menu={menu}
                  setActive={setActive}
                  style={bgColorDropDown}
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </nav>
  );
}
